import Details from "../operationalIndicator/Details.component";
import { useEffect, useState } from 'react';
import { AssesmentInterface, CommentInterface, ICardInterface } from '../../store/details/assessment/interface/AssesmentInterface';
import { getAssesments, getRatingComment } from '../../store/details/Details.service';
import {format} from 'date-fns';
import Progress from '../../../component/progress/Progress.component';
import Card from '../component/Card.component';
import { getUserById } from '../../store/details/User.service';

export default function Assesment() {

    const [load, setLoad] = useState(true);
    const [assessmentList, setAssessmentList] = useState<AssesmentInterface[]>([]);

    const getAssesment = async () => {
        const comments = await getRatingComment().then((res) => {
            return res.data
        });

        setTimeout(async () => {
            const result: AssesmentInterface[] = await getAssesments().then(async({data}) => {

                data.sort(function(a: AssesmentInterface , b: AssesmentInterface) {
                    if (a.createdAt > b.createdAt) {
                        return -1;
                    } else {
                        return 1;
                    }
                })

                const assesments = data.map((assesment: AssesmentInterface) => {
                    const commentDescription: CommentInterface = comments.find((comment: CommentInterface) => comment.idAvaliacao.id === assesment.id);
                    return {
                        id: assesment.id,
                        title: assesment.idUsuario,
                        subTitle: commentDescription !== undefined ? commentDescription.dsComentario : '',
                        score: assesment.vlrPerguntaNPS,
                        date: format(new Date(assesment.createdAt), "dd/MM/yyyy"),
                        store: assesment.idLoja
                    }
                })
                return assesments;
            });

            getFullName(result);

        }, 1.0*1000)
    }

    const getFullName = (list: any[]) => {
        list.forEach(async (item) => {
            const name = await getUserById(item.title).then((result) => result.data);
            await name.user.status === false ? item.title="" : item.title = name.user.cn;
            setAssessmentList(assessmentList => [...assessmentList, item]);
        });
        setLoad(false);
    }

    useEffect(() => {
        getAssesment();
    }, [])

    return (
    
        <>
            <Details />
            <Progress open={load} />
            {assessmentList !== null && load === false && <Card data={assessmentList} request={false} />}
        </>
    )
}